module.exports = __webpack_public_path__ + "static/media/logo.bec83ac5.png";